import _ from 'lodash'
import React, { useState } from 'react'
import useError from '@vero/ui-core-browser/hooks/error.js'
import useEnv from '@vero/ui-core-browser/hooks/env.js'
import useCompanies from '../hooks/companies.js'
import Company from './company.jsx'

export default function () {
  const [loading, setLoading] = useState(false)
  const { error, setError, handleError } = useError()
  const { env } = useEnv()
  const { companies } = useCompanies(setLoading, setError, handleError)

  return (
    <div className='container mx-auto md:p-4'>
      {error && <div className='alert alert-error'>{error}</div>}

      {!_.isEmpty(companies) && (
        <div className='grid md:grid-cols-2 xl:grid-cols-3 md:gap-4'>
          {_.chain(
            companies
          ).reject(
            company => (company?.demo && env !== 'demo' && company?.slug !== 'vero-stakeholders') || (!company?.demo && env === 'demo')
          ).map(
            company => (
              <Company
                key={company?.slug}
                company={company}
                card
              />
            )
          ).value()}
        </div>
      )}

      {!loading && !error && _.isEmpty(companies) && (
        <div className='alert alert-info'>You do not have access to any companies.</div>
      )}

      {loading && (
        <div className='text-center p-8'>
          <span className='loading loading-spinner' />
        </div>
      )}
    </div>
  )
}
